import axios from 'axios'

export default async (id, rut, from = null, to = null) => {
    console.log(2, from, to)
    let route =
        process.env.VUE_APP_API_ROUTE +
        '/sl_customer/' +
        id +
        '/receivable_pdf?'
    if (from) route += `from=${from}&`
    if (to) route += `to=${to}`
    let response = await axios.get(route, { responseType: 'blob' })

    const linkSource = URL.createObjectURL(response.data)
    const downloadLink = document.createElement('a')
    const fileName = `CLIENTE-${rut}-CARTOLA_MOVIMIENTOS.pdf`
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
}
